import { Component, OnInit, ViewChild, Injectable, Inject, Input } from '@angular/core';
import { ENPOINT } from './../../services/endpoint';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ComplementsService } from './../../services/complements/complements.service';
import { GeneralService } from './../../services/admin/general.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};


@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}


@Component({
  selector: 'app-seecomplement',
  templateUrl: './see-complement.component.html',
  styleUrls: ['./see-complement.component.scss'],
  providers: [GeneralService, CatalogsService, ComplementsService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class SeeComplementComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @ViewChild('filtersCheckInv') filtersCheckInv: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  rows: any[] = [];

  private basePath;
  closeResult: string;
  public user: User;
  rol;
  proveedores;
  modalFilters;
  complementosVer;
  modalDetalle;
  verDetalle = false;

  detalle = {
    ctaOrdenante: '',
    emisor: '',
    estatus: '',
    fechaCarga: '',
    fechaComplemento: '',
    fechaContabilizacion: '',
    fechaDePago: '',
    folio: '',
    formaDePago: '',
    id: '',
    listaPagosRelacionados: '',
    docRelacionado: '',
    metodoPago: '',
    moneda: '',
    numParcialidad: '',
    uuidComplemento: '',
    lugarExpedicion: '',
    metodoDePago: '',
    noDocumento: '',
    numOperacion: '',
    proveedor: '',
    receptor: '',
    rutaPdf: '',
    rutaXml: '',
    sociedad: '',
    subtotal: '',
    tipoDeComprobante: '',
    total: '',
    usuarioCargo: '',
    uuid: '',
    version: '',
  };

  proveedorBusqueda;
  verListado = false;
  flagBusqueda = false;
  flagEntradas;
  flagDatos;
  flagMensaje;
  docPdf;
  docXml;
  busy = false;
  busyBusqueda: boolean = false;
  busyListado: boolean = false;

  fechaMax;
  fechaMin;
  diasTranscurridos;

  relacionados = [];
  toastRangoFechasValido;
  toast90dias;
  camposVacios = false;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  btnFiltros;
  constructor(
    private general: GeneralService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private catalogo: CatalogsService,
    private complementos: ComplementsService,
    private translate: TranslateService,
  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });

    this.translate.get('texto.rangoFechas90').subscribe(
      text => {
        this.toast90dias = text;
      });

    this.getProveedores();
    this.basePath = ENPOINT.url;

  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    // this.openFilters();
    if (this.rol === 3) {
      this.cargarFacturas();
      this.btnFiltros = true;
      this.flagEntradas = false;
    } else {
      this.btnFiltros = false;
      this.flagEntradas = true;
    }

  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Ver complementos').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.logout();
        } 
      }
    );
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogo.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  openFilters() {

    this.modalFilters = this.modalService.open(this.filtersCheckInv, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      if (result === 'x') {
        this.flagMensaje = false;
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onDateSelect(e) {
    (<HTMLInputElement>document.getElementById('fechafOpt')).value = null;
  }

  reload() {
    this.busyListado = true;
    this.getFacturas();
  }

  cargarFacturas() {
    this.busy = true;
    this.getFacturas();
  }

  proveedorFilter;
  noDocumentoFilter;
  getFacturas() {
    // this.busy = true;
    this.flagDatos = false;
    this.verDetalle = false;
    this.busyBusqueda = true;
    this.detalle.id = '';
    const estatus = 'Cargado';
    let noDocumento = '';
    const rol = this.user.rol.id;

    let proveedor;
    if (rol === 3) {
      //this.busy = true;
      proveedor = this.user.id;
    } else {
      proveedor = this.proveedorFilter;
    }

    /* Fecha actual */
    var hoy: any = new Date();
    var dd: any = hoy.getDate();
    var mm: any = hoy.getMonth() + 1;
    var yyyy = hoy.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    var fechaHoy = yyyy + '-' + mm + '-' + dd;

    /* Fecha 15 dias antes */
    let dieciseisDias = 1000 * 60 * 60 * 24 * 15;
    let resta = hoy.getTime() - dieciseisDias;
    let fechaAtras = new Date(resta);

    var ddAtras: any = fechaAtras.getDate();
    var mmAtras: any = fechaAtras.getMonth() + 1;
    var yyyyAtras: any = fechaAtras.getFullYear();

    if (ddAtras < 10) {
      ddAtras = '0' + ddAtras;
    }

    if (mmAtras < 10) {
      mmAtras = '0' + mmAtras;
    }

    var fechaAnterior = yyyyAtras + '-' + mmAtras + '-' + ddAtras;

    //this.busyListado = true;
    this.complementos.getComplementos(proveedor, fechaAnterior, fechaHoy, estatus, noDocumento).subscribe(
      data => {
        this.busy = false;
        this.busyBusqueda = false;
        this.busyListado = false;

        if (data != null) {
          //  this.proveedorFilter = null;
          this.complementosVer = data.complemento;
          this.flagEntradas = false;

          /*  if (this.complementosVer.length > 0) {
              this.btnFiltros = true;
            } else {
              this.btnFiltros = false;
            }*/

          if (this.complementosVer.length === 0) {
            this.flagDatos = true;
            this.verListado = false;
          } else {
            this.flagDatos = false;
            this.verListado = true;
          }

        }


      },
      err => {
        this.busy = false;
        this.busyListado = false;
        if (err.status === 401) {
          this.storageService.logout();
        } 
      },
    );
  }

  restaFechas(f1, f2) {
    var aFecha1 = f1.split('/');
    var aFecha2 = f2.split('/');
    var fFecha1 = Date.UTC(aFecha1[2], aFecha1[1] - 1, aFecha1[0]);
    var fFecha2 = Date.UTC(aFecha2[2], aFecha2[1] - 1, aFecha2[0]);
    var dif = fFecha2 - fFecha1;
    this.diasTranscurridos = Math.floor(dif / (1000 * 60 * 60 * 24));
    return this.diasTranscurridos;
  }

  buscarFacturas() {
    //this.busyBusqueda = true;
    this.detalle.id = '';
    this.verDetalle = false;
    let flagVerFacturas = false;
    let proveedor;
    const estatus = 'Cargado';
    let noDocumento = '';

    if (this.rol === 2) {
      proveedor = this.proveedorBusqueda;
    } else {
      proveedor = this.user.id;
    }

    const fechaI = (<HTMLInputElement>document.getElementById('fechaiOpt')).value;
    const fechaF = (<HTMLInputElement>document.getElementById('fechafOpt')).value;


    if (proveedor == null || fechaI === '' || fechaF === '') {
      flagVerFacturas = false;
    } else {
      if (fechaI <= fechaF) {
        var d = new Date(fechaI);
        var d2 = new Date(fechaF);

        var r = d.getDate();
        var r2 = d.getMonth() + 1;
        var r3 = d.getFullYear();

        var ff = d2.getDate();
        var ff2 = d2.getMonth() + 1;
        var ff3 = d2.getFullYear();


        var f1 = r + '/' + r2 + '/' + r3;
        var f2 = ff + '/' + ff2 + '/' + ff3;

        this.restaFechas(f1, f2);

        if (this.diasTranscurridos > 90) {
          this.toasterService.pop('error', 'ERROR', this.toast90dias);
        } else {
          flagVerFacturas = true;
        }
      } else {
        this.toasterService.pop('error', 'ERROR', this.toastRangoFechasValido);
      }
    }

    if (flagVerFacturas) {
      this.busyListado = true;
      this.busyBusqueda = true;
      this.flagEntradas = false;
      this.camposVacios = false;
      this.complementos.getComplementos(proveedor, fechaI, fechaF, estatus, noDocumento).subscribe(
        data => {
          this.busy = false;
          this.busyBusqueda = false;
          this.busyListado = false;
          this.proveedorFilter = this.proveedorBusqueda;

          if (data != null) {
            this.complementosVer = data.complemento;

            if (this.complementosVer.length === 0) {
              this.flagDatos = true;
              this.verListado = false;
            } else {
              this.flagDatos = false;
              this.verListado = true;
            }

            //  this.proveedorFilter = null;
          }

          this.modalFilters.close();
        },
        err => {
          this.busyListado = false;
          this.busyBusqueda = false;
          if (err.status === 401) {
            this.storageService.logout();
          } 
        },
      );
    } else {
      this.camposVacios = true;
    }

  }

  detalleComplemento(index) {
    this.relacionados = [];
    this.verDetalle = true;
    this.detalle.ctaOrdenante = this.complementosVer[index].ctaOrdenante;
    this.detalle.emisor = this.complementosVer[index].emisor;
    this.detalle.estatus = this.complementosVer[index].estatus;
    this.detalle.fechaCarga = this.complementosVer[index].fechaCarga;
    this.detalle.fechaComplemento = this.complementosVer[index].fechaComplemento;
    this.detalle.fechaContabilizacion = this.complementosVer[index].fechaContabilizacion;
    this.detalle.fechaDePago = this.complementosVer[index].fechaDePago;
    this.detalle.folio = this.complementosVer[index].folio;
    this.detalle.formaDePago = this.complementosVer[index].formaDePago;
    this.detalle.id = this.complementosVer[index].id;
    this.detalle.listaPagosRelacionados = this.complementosVer[index].listaPagosRelacionados;
    this.detalle.docRelacionado = this.complementosVer[index].docRelacionado;
    this.detalle.metodoPago = this.complementosVer[index].metodoPago;
    this.detalle.moneda = this.complementosVer[index].moneda;
    this.detalle.numParcialidad = this.complementosVer[index].numParcialidad;
    this.detalle.uuidComplemento = this.complementosVer[index].uuidComplemento;
    this.detalle.lugarExpedicion = this.complementosVer[index].lugarExpedicion;
    this.detalle.metodoDePago = this.complementosVer[index].metodoDePago;
    this.detalle.moneda = this.complementosVer[index].moneda;
    this.detalle.noDocumento = this.complementosVer[index].noDocumento;
    this.detalle.numOperacion = this.complementosVer[index].numOperacion;
    this.detalle.proveedor = this.complementosVer[index].proveedor;
    this.detalle.receptor = this.complementosVer[index].receptor;
    this.detalle.rutaPdf = this.complementosVer[index].rutaPdf;
    this.detalle.rutaXml = this.complementosVer[index].rutaXml;
    this.detalle.sociedad = this.complementosVer[index].sociedad;
    this.detalle.subtotal = this.complementosVer[index].subtotal;
    this.detalle.tipoDeComprobante = this.complementosVer[index].tipoDeComprobante;
    this.detalle.total = this.complementosVer[index].total;
    this.detalle.usuarioCargo = this.complementosVer[index].usuarioCargo;
    this.detalle.uuid = this.complementosVer[index].uuid;
    this.detalle.version = this.complementosVer[index].version;

    if (this.complementosVer[index].listaPagosRelacionados) {
      this.relacionados.push(this.complementosVer[index].listaPagosRelacionados);
    }

    if (this.complementosVer[index].listaPagosRelacionados.length > 0) {
      this.rows = this.relacionados[0];
    } else {
      this.rows = this.relacionados;
    }


  }

  openMasDetalle(masDetalle) {

    this.modalDetalle = this.modalService.open(masDetalle, { centered: true, keyboard: false, backdrop: 'static', size: 'lg' });
    this.modalDetalle.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  descargaPdf(value) {
    this.docPdf = value; 
    this.getPdf();
  }

  getPdf() {
    const srcFile = this.docPdf;

    if (srcFile) {
      const srcB64 = btoa(srcFile);
     
      this.complementos.downloadPdf(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Documento.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );
    }
  }

  descargaXml(value) {
    this.docXml = value;
    this.getXml();
  }

  getXml() {
    const srcFile = this.docXml;

    if (srcFile) {
      const srcB64 = btoa(srcFile);
      
      this.complementos.downloadXml(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Documento.xml`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el XML:', error);
        }
      );
      
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/see-complement/see-complement.component.ts